<template>
  <div class="min-h-screen bg-gradient-to-br from-psychology-calm via-white to-psychology-warm">
    <!-- 背景装饰 -->
    <div class="absolute inset-0 pointer-events-none overflow-hidden">
      <div class="absolute top-20 left-10 w-32 h-32 bg-psychology-primary/5 rounded-full blur-xl"></div>
      <div class="absolute top-40 right-16 w-24 h-24 bg-psychology-accent/5 rounded-full blur-lg"></div>
      <div class="absolute bottom-32 left-1/3 w-40 h-40 bg-psychology-secondary/5 rounded-full blur-xl"></div>
    </div>

    <!-- 导航栏 -->
    <nav class="relative z-10 bg-white/80 backdrop-blur-sm border-b border-gray-200">
      <div class="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex items-center justify-between h-16">
          <router-link to="/" class="flex items-center space-x-3 hover:opacity-80 transition-opacity">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-8 h-8 text-psychology-primary">
              <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
            </svg>
            <span class="text-xl font-semibold text-gray-900">RPI Calculator</span>
          </router-link>
          <div class="flex items-center space-x-4">
            <router-link to="/" class="text-gray-600 hover:text-gray-900 transition-colors">首页</router-link>
            <a href="#" class="text-gray-600 hover:text-gray-900 transition-colors">科学依据</a>
          </div>
        </div>
      </div>
    </nav>

    <!-- 主要内容 -->
    <div class="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <!-- 页面标题 -->
      <GuideHeader />

      <div class="space-y-8">
        <!-- 快速开始 -->
        <QuickStart />

        <!-- 测评流程 -->
        <ProcessSteps />

        <!-- 答题建议 -->
        <AnswerTips />

        <!-- 双视角说明 -->
        <DualPerspective />

        <!-- 注意事项 -->
        <ImportantNotes />

        <!-- 结果解读 -->
        <ResultGuide />

        <!-- CTA按钮 -->
        <GuideCTA />
      </div>
    </div>

    <!-- 回到顶部 -->
    <BackToTop />
  </div>
</template>

<script>
import GuideHeader from '../components/guide/GuideHeader.vue'
import QuickStart from '../components/guide/QuickStart.vue'
import ProcessSteps from '../components/guide/ProcessSteps.vue'
import AnswerTips from '../components/guide/AnswerTips.vue'
import DualPerspective from '../components/guide/DualPerspective.vue'
import ImportantNotes from '../components/guide/ImportantNotes.vue'
import ResultGuide from '../components/guide/ResultGuide.vue'
import GuideCTA from '../components/guide/GuideCTA.vue'
import BackToTop from '../components/BackToTop.vue'

export default {
  name: 'GuidePage',
  components: {
    GuideHeader,
    QuickStart,
    ProcessSteps,
    AnswerTips,
    DualPerspective,
    ImportantNotes,
    ResultGuide,
    GuideCTA,
    BackToTop
  }
}
</script>

